import Api from "utils/api/Api"
export const getBookReportList = (params)=>{
    const requestData = params?.queryKey[1];
    return Api.post(`/api/book_report/list?page=${requestData.page}`, requestData);
}

export const apiGetReportPopularBooks = ()=>Api.get('/api/book_report/popular/books');
export const apiDeleteBookReport = (id)=> Api.get(`/api/book_report/${id}/delete`);


export const apiStoreReportTemp = (data)=>Api.post(`/api/book_report/store/temp`, data);
export const apiGetReportTemp = (params)=>Api.get(`/api/book_report/temp/${params?.queryKey[1]}`);

export const apiStoreReport = (data)=>Api.post(`/api/book_report/store`, data);